import React, { useRef } from 'react';
import '../../../styles/components/MyJobsList/MyJobCard.scss';
import PropTypes from 'prop-types';
import mainMitraLogo from '../../../assets/mitra-main-logo.png';
import defaultCompanyIcon from '../../../assets/defaultCompany.svg';
import uploadDocsIcon from '../../../assets/jc_upload_docs.svg';
import profilePicIcon from '../../../assets/jc_camera_icon.svg';
import bankDetailsIcon from '../../../assets/jc_bank_details.svg';
import docUploadIcon from '../../../assets/doc_upload_icon.svg';
import successIcon from '../../../assets/success.png';
import failIcon from '../../../assets/fail.png';
import pendingIcon from '../../../assets/pending.png';
import RoutingService from '../../../services/RoutingService';
import useMoengage from '../../../hooks/useMoengage';
import axios from 'axios';
import TrainingCard from '../TrainingCard';
import { useEffect } from 'react';

const JOB_STATUSES_ENUM = {
  APPLICATION_INITIATED: 'Application Initiated',
  DOCUMENTS_UPLOADED: 'Document Upload',
  BACKGROUND_CHECK: 'Background Check',
  ONBOARDING_FEE: 'Onboarding Fee',
  ONBOARDED: 'Onboarded',
};

const status_arr = [
  {
    type: 'Application Initiated',
    result: 'passed',
    status: 'success',
    timestamp: null,
  },
  {
    type: 'Documents Upload',
    result: 'passed',
    status: 'success',
    timestamp: null,
    documentMandatory: true,
    profilePhotoRequired: true,
    profilePhotoUploaded: false,
  },
  {
    type: 'Add Bank Details',
    result: 'pending',
    status: 'pending',
    timestamp: null,
    bankValidationFlag: 'pending',
  },
  {
    type: 'Background Check',
    result: 'pending',
    status: 'pending',
    timestamp: null,
    trainingInfo: {
      appColor: '#01B5A2',
      appIcon: 'https://uploads-a.vahan.co/OUST-logo.svg',
      appName: 'Oust App',
      appUrl: 'https://play.google.com/store/apps/details?id=com.oustme.oustapp&hl=en_IN&gl=US',
    },
  },
  {
    type: 'Onboarding',
    result: 'pending',
    status: 'pending',
    timestamp: null,
  },
];

const STATUS_ICON_ENUM = {
  success: successIcon,
  pending: pendingIcon,
  fail: failIcon,
};

const application_initiated_status_label = 'Application Initiated';
const doc_upload_status_label = 'Document Upload';
const doc_uploaded_status_label = 'Document Uploaded';
const add_bank_details_label = 'Add Bank Details';
const background_check_label = 'Background Check';
const onboarding_label = 'Onboarding';
// const trainingInfo = {
//   appName: 'Oust App',
//   appIcon: 'https://uploads-a.vahan.co/OUST-logo.svg',
//   appUrl: 'https://play.google.com/store/apps/details?id=com.oustme.oustapp&hl=en_IN&gl=US',
//   appColor: '#01B5A2',
// };

function MyJobCard(props) {
  const pendingStopper = useRef(true);
  const trackEvent = useMoengage()[1];
  let rejectedStopper = false;

  // useEffect(() => {
  //   status = JSON.parse(JSON.stringify(status_arr));
  // }, [])

  const getStatus = status => {
    if (pendingStopper.current && status === 'pending') {
      pendingStopper.current = false;
      return 'Pending';
    }
    return '';
  };

  const isInPendingState = inp => {
    var isPending = false;
    //change status_arr to props.status
    props.status.forEach((item, index) => {
      if (item.type == inp && item.status == 'pending') {
        isPending = true;
      }
    });
    return isPending;
  };

  const checkRejectedStatus = status => {
    // change status_arr to status
    status.map(el => {
      if (el.status == 'rejected' || el.status == 'fail') rejectedStopper = true;
    });
  };

  const clickView = userId => {
    trackEvent('view_button_click');
    RoutingService.gotoMyJobDetails({
      search: `userId=${encodeURIComponent(userId)}`,
      jobDetails: props,
    });
  };

  var { baseSalary, role, companyName, city, viewJob, status, userId, companyLogo } = props;
  return (
    <div className="my_job_card">
      <div className="salary_div">
        <div>
          <span className="salary_amt">
            {/* change status to status_arr */}
            {checkRejectedStatus(status)}
            {baseSalary}
            <small>/ month</small>
          </span>
          <p>{role}</p>
        </div>
        {/* && !isInFirstStage() */}
        {viewJob && (
          <button
            type="button"
            className={rejectedStopper == true ? 'disabled_button' : 'view_button'}
            onClick={() => {
              clickView(userId);
            }}
          >
            VIEW
          </button>
        )}
      </div>
      <div className="company_div">
        <img
          src={companyLogo || defaultCompanyIcon}
          alt="companyName"
          style={{ borderRadius: '50%', display: 'inline', maxWidth: '55px' }}
        />
        <div>
          <h4>{companyName}</h4>
          <small>{city}</small>
        </div>
      </div>
      <div className="job_status_div">
        {/* change status_arr to status */}
        {status.map((el, index) => {
          return (
            <div className="job-card-parent disp-flex flex-col aifs" key={el.type}>
              <div className="upper-parent disp-flex">
                <div className="status-icn-div">
                  <img
                    src={STATUS_ICON_ENUM[el.status] || STATUS_ICON_ENUM.pending}
                    alt="icon"
                    style={{ maxWidth: '30px' }}
                    className="status-icn-img"
                  />
                </div>
                <div className="status-text-parent disp-flex">
                  <div>{JOB_STATUSES_ENUM[el.type] || el.type}</div>

                  <div className="pending-state-txt">{getStatus(el.status)}</div>
                </div>
              </div>

              {
                // change status_arr to status
                <div
                  className={`lower-parent disp-flex ${
                    index !== status.length - 1 ? 'display-left-line' : 'marl-14'
                  }`}
                >
                  <div className="timestamp-btn-training-parent">
                    {el.timestamp && (
                      <div className="timestamp-parent">
                        (
                        <span className="date-exists">
                          {new Date(el.timestamp).toLocaleString('en-IN', { dateStyle: 'short' })} |{' '}
                          {new Date(el.timestamp).toLocaleString('en-US', {
                            hour12: true,
                            hour: '2-digit',
                            minute: '2-digit',
                          })}
                        </span>
                        )
                      </div>
                    )}

                    <div className="upload-verify-training-btn-parent">
                      <div className="upload-btn-parent">
                        {viewJob &&
                        el.type == doc_upload_status_label &&
                        isInPendingState(doc_upload_status_label) &&
                        el.documentMandatory ? (
                          <a
                            className="hyperlink-anchor"
                            href="https://jsonplaceholder.typicode.com/todos/1"
                          >
                            <button
                              type="button"
                              className="btn-outline"
                              onClick={() => {
                                trackEvent('nonpayroll_document_upload_clicked');
                              }}
                            >
                              <span>
                                <img src={uploadDocsIcon} alt="" />
                              </span>
                              <span className="btn-txt">Upload Documents</span>
                            </button>
                          </a>
                        ) : null}
                      </div>

                      <div className="profile-btn-parent">
                        {/* && isInPendingState(doc_upload_status_label) && el.profilePhotoRequired && !el.profilePhotoUploaded */}
                        {viewJob &&
                        el.type == doc_upload_status_label &&
                        isInPendingState(doc_upload_status_label) &&
                        el.profilePhotoRequired &&
                        !el.profilePhotoUploaded ? (
                          <a
                            className="hyperlink-anchor"
                            href="https://jsonplaceholder.typicode.com/users/1"
                          >
                            <button type="button" className="btn-outline mart-18">
                              <span>
                                <img src={profilePicIcon} alt="" />
                              </span>
                              <span className="btn-txt">Add a Profile Pic</span>
                            </button>
                          </a>
                        ) : null}
                      </div>

                      <div className="add-bank-btn-parent">
                        {/* && el.type == doc_upload_status_label && !bankValidationFlag */}
                        {viewJob &&
                        el.type == add_bank_details_label &&
                        isInPendingState(add_bank_details_label) &&
                        !isInPendingState(doc_upload_status_label) &&
                        (el.bankValidationFlag == 'false' || el.bankValidationFlag == 'pending') ? (
                          <div className="disp-flex aic mart-22">
                            <a
                              className={`hyperlink-anchor ${
                                el.bankValidationFlag == 'pending' ? 'disable-link' : ''
                              }`}
                              href="https://jsonplaceholder.typicode.com/posts/1"
                            >
                              <button
                                type="button"
                                className="btn-outline"
                                disabled={el.bankValidationFlag == 'pending' ? true : false}
                                onClick={() => {
                                  trackEvent('nonpayroll_bank_verification_clicked');
                                }}
                              >
                                <span>
                                  <img src={bankDetailsIcon} alt="" />
                                </span>
                                <span className="btn-txt">Add Bank Details</span>
                              </button>
                            </a>

                            {el.bankValidationFlag == 'pending' ? (
                              <div className="pending-state-txt">Pending</div>
                            ) : null}
                          </div>
                        ) : null}
                      </div>

                      <div className="add-bank-docs-btn-parent">
                        {/* && el.type == doc_upload_status_label && !bankValidationFlag */}
                        {viewJob &&
                        el.type == add_bank_details_label &&
                        isInPendingState(add_bank_details_label) &&
                        !isInPendingState(doc_upload_status_label) &&
                        el.bankDocumentRequired &&
                        !el.bankDocumentUploaded ? (
                          <div className="disp-flex aic mart-22">
                            <a className="hyperlink-anchor" href="https://jsonplaceholder.typicode.com/albums/1">
                              <button
                                type="button"
                                className="btn-outline"
                                // onClick={() => {
                                //   trackEvent("nonpayroll_bank_verification_clicked");
                                // }}
                              >
                                <span>
                                  <img src={docUploadIcon} alt="" />
                                </span>
                                <span className="btn-txt">Upload bank passbook/cheque</span>
                              </button>
                            </a>
                          </div>
                        ) : null}
                      </div>

                      <div className="training-info-parent">
                        {viewJob &&
                        el.trainingInfo &&
                        !isInPendingState(add_bank_details_label) &&
                        (el.type == onboarding_label || el.type == background_check_label) ? (
                          <TrainingCard trainingInfo={el.trainingInfo}></TrainingCard>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              }
              {/* <p>
                <img
                  src={STATUS_ICON_ENUM[el.status] || STATUS_ICON_ENUM.pending}
                  alt="icon"
                  style={{ maxWidth: '30px' }}
                />
                <span className={el.status}>{JOB_STATUSES_ENUM[el.type] || el.type}</span>
                <span style={{ color: '#D34729' }}>{getStatus(el.status)}</span>
              </p> */}
              {/* {el.timestamp && (
                <span className="date-exists">
                  {new Date(el.timestamp).toLocaleString('en-IN', { dateStyle: 'short' })} |{' '}
                  {new Date(el.timestamp).toLocaleString('en-US', {
                    hour12: true,
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </span>
              )}
              {!el.timestamp && <span> </span>}
              </div>*/}
            </div>
          );
        })}
        {rejectedStopper == true && (
          <button
            type="button"
            className="apply_button"
            onClick={() => {
              trackEvent('alt_job_interested_clicked', {
                company: { companyName },
                page: 'Job Status',
              });
              RoutingService.gotoMyNotAppliedJobs({
                search: `userId=${encodeURIComponent(userId)}`,
              });
            }}
          >
            Apply Jobs
          </button>
        )}
      </div>
    </div>
  );
}

MyJobCard.propTypes = {
  status: PropTypes.arrayOf(PropTypes.object).isRequired,
  baseSalary: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  companyName: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  viewJob: PropTypes.bool,
  userId: PropTypes.string.isRequired,
  companyLogo: PropTypes.string,
};

MyJobCard.defaultProps = {
  viewJob: false,
  companyLogo: null,
};

export default MyJobCard;
